import { defineMessages } from 'react-intl'

export default defineMessages({
  readMore: {
    id: 'features_page_readmore',
    defaultMessage: 'Read more',
  },
  title: {
    id: 'Jumbotron.intro.title',
    defaultMessage: 'Healthy living.',
  },
  subTitle: {
    id: 'Jumbotron.intro.subtitle',
    defaultMessage: 'Simplified.',
  },
  check1: {
    id: 'Jumbotron.intro.check1',
    defaultMessage: 'Lose weight',
  },
  check2: {
    id: 'Jumbotron.intro.check2',
    defaultMessage: 'Get stronger',
  },
  check3: {
    id: 'Jumbotron.intro.check3',
    defaultMessage: 'Eat better',
  },
  homepage_reviews_copy: {
    id: 'homepage_reviews_copy',
    defaultMessage: 'reviews and counting!',
  },
  homepage_tagline: {
    id: 'homepage_tagline',
    defaultMessage:
      'The digital self-care app that helps you reach your health and weight goals through better eating.',
  },
})
